<template>
	<div>
		<v-tabs
			v-model="currExecutiveIndex"
			:color="themeInputColor"
			dark
			slider-color="yellow"
			show-arrows
			@change="tabIndex => onTabChange(tabIndex, true)"
			class="mb-4"
		>
			<v-tab
				v-for="executive in executivesList"
				:key="executive.userId"
				ripple
				>{{ executive.retailerName }}</v-tab
			>
		</v-tabs>
		<v-tabs
			v-model="currDateIndex"
			:color="themeInputColor"
			dark
			slider-color="yellow"
			show-arrows
			@change="onTabChange"
			class="mb-4"
		>
			<v-tab v-for="date in dateArray" :key="date.value" ripple>{{
				date.name
			}}</v-tab>
		</v-tabs>
		<v-card
			v-for="(item, index) in retailersVisitList"
			:key="item.userId"
			style="display:flex;justify-content: space-between;"
			class="mb-2 px-2"
			><div class="pa-2 alignInColumn">
				<div class="font-weight-bold mb-2">
					{{ item.retailerName || "-" }}
					<v-tooltip
						right
						v-if="
							item.visit &&
								item.visit.status === PENDING &&
								item.visit.purposeOfVisit
						"
					>
						<template v-slot:activator="{ on }">
							<v-icon
								color="primary"
								dark
								v-on="on"
								style="cursor:pointer"
								size="20"
								>info</v-icon
							>
						</template>
						<span>{{ item.visit.purposeOfVisit }}</span>
					</v-tooltip>
				</div>
				<div>{{ item.phoneNo || "-" }}</div>
				<div v-if="item.lastVisited">
					Last visited on
					{{ new Date(item.lastVisited).toLocaleDateString() }}
				</div>
			</div>
			<div class="pa-2">
				<v-switch
					v-model="toggleArray[index]"
					@change="switchValue => toggleSwitch(switchValue, item)"
					:disabled="checkToggleDisabled(item)"
				></v-switch></div
		></v-card>
		<v-dialog v-model="showDialog" persistent>
			<v-card>
				<v-btn
					icon
					class="top-right-align"
					@click="onTabChange(currDateIndex)"
				>
					<v-icon>close</v-icon>
				</v-btn>
				<v-card-title>
					<span class="headline">Add Purpose of Visit</span>
				</v-card-title>
				<v-text-field
					label="Purpose"
					class="pa-2"
					@input="val => (visitPurpose = val)"
				></v-text-field>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click="scheduleRetailVisit"
						:disabled="!visitPurpose"
						>Submit</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import {
	RETAILERS_VISIT_LIST,
	SCHEDULE_RETAIL_VISIT
} from "../../store/action-types";
import { THEME_INPUT_COLOUR } from "../constants";
import EventsManager from "@/event-manager";

export default {
	data: () => ({
		themeInputColor: THEME_INPUT_COLOUR,
		dateArray: [],
		currDateIndex: 7,
		isLoading: false,
		retailersVisitList: [],
		executivesList: [],
		currExecutiveIndex: 0,
		isFirstCall: true,
		ACCEPTED: "accepted",
		PENDING: "pending",
		INACTIVE: "inactive",
		showDialog: false,
		visitPurpose: "",
		status: "",
		selectedRetailer: {},
		toggleArray: []
	}),
	mounted() {
		this.sendEvent();
		this.dateArrayGenerator();
		this.fetchRetailersVisitList(this.userId);
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		})
	},
	methods: {
		fetchRetailersVisitList(userId) {
			this.isLoading = true;
			this.$store
				.dispatch(RETAILERS_VISIT_LIST.dispatch, {
					userId,
					limit: 100,
					offset: 0,
					date: this.dateArray[this.currDateIndex].value
				})
				.then((data = {}) => {
					this.retailersVisitList = data.retailers || [];
					this.retailersVisitList.sort((a, b) =>
						a.visit && a.visit.status === this.PENDING
							? -1
							: b.visit && b.visit.status === this.PENDING
							? 1
							: a.shopStatus !== this.ACCEPTED
							? 1
							: b.shopStatus !== this.ACCEPTED
							? -1
							: new Date(
									a.lastVisited ? a.lastVisited : new Date()
							  ).getTime() -
							  new Date(
									b.lastVisited ? b.lastVisited : new Date()
							  ).getTime()
					);
					this.toggleArray = this.retailersVisitList.map(
						item => item.visit && item.visit.status === this.PENDING
					);
					this.executivesList =
						data.executives || this.executivesList;
					if (this.isFirstCall)
						this.fetchRetailersVisitList(
							this.executivesList[this.currExecutiveIndex].userId
						);
					this.isFirstCall = false;
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		scheduleRetailVisit() {
			this.isLoading = true;
			this.$store
				.dispatch(SCHEDULE_RETAIL_VISIT.dispatch, {
					retailerId: this.selectedRetailer.userId,
					visitorId: this.executivesList[this.currExecutiveIndex]
						.userId,
					status: this.status,
					scheduledTime: this.dateArray[this.currDateIndex].value,
					purposeOfVisit: this.visitPurpose
				})
				.then(() => {
					this.showDialog = false;
					this.visitPurpose = "";
					this.fetchRetailersVisitList(
						this.executivesList[this.currExecutiveIndex].userId
					);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		onTabChange(tabIndex, isExecutive) {
			this.showDialog = false;
			isExecutive
				? (this.currExecutiveIndex = tabIndex)
				: (this.currDateIndex = tabIndex);
			this.fetchRetailersVisitList(
				this.executivesList[this.currExecutiveIndex].userId
			);
		},
		dateArrayGenerator() {
			const date = new Date();
			let i = -7;
			while (i <= 7) {
				const ithDate = new Date(
					date.getFullYear(),
					date.getMonth(),
					date.getDate() + i
				);
				const dateValue = ithDate.toLocaleDateString().split("/");
				const dateName = ithDate.toLocaleString("default", {
					month: "short",
					day: "numeric"
				});
				this.dateArray.push({
					name: dateName,
					value: `${dateValue[2]}-${dateValue[1]}-${dateValue[0]}`
				});
				i++;
			}
		},
		checkToggleDisabled(item) {
			const date = new Date();
			const noonTime = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate(),
				12,
				0
			).getTime();
			const currTime = date.getTime();
			const selectedDate = this.dateArray[this.currDateIndex].value;
			const selectedTime = new Date(selectedDate).getTime();
			if (item.shopStatus !== this.ACCEPTED) return true;
			if (
				selectedTime > currTime ||
				(selectedDate.split("-")[2] ===
					date.toLocaleDateString().split("/")[0] &&
					currTime < noonTime)
			)
				return false;
			return true;
		},
		toggleSwitch(switchValue, item) {
			this.visitPurpose = "";
			this.status = switchValue ? this.PENDING : this.INACTIVE;
			this.selectedRetailer = item;
			if (!switchValue) {
				this.scheduleRetailVisit();
				return;
			}
			this.showDialog = true;
		},
		sendEvent() {
			EventsManager.sendEvent({
				name: "WEEK_PLANNING_TAB_OPENED",
				properties: {
					userId: this.userId
				}
			});
		}
	}
};
</script>

<style scoped>
.alignInColumn {
	display: flex;
	flex-direction: column;
}
</style>
